import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as HeroIcons from "@heroicons/react/20/solid";
import { FunctionComponent, SVGProps } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { iconsSchemas } from "../../config/entities";
import { isCustomEntityIconToken } from "../../utils/icon-utils";
import { IconRenderer } from "./IconRenderer";

const wrapSvg = (innerSvg: string, size = 24): string => {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
      ${innerSvg}
    </svg>
  `;
};

// this returns the raw SVG markup string
export const getRawSvgForIcon = (icon: string): string | undefined => {
  // Custom raw string (preferred)
  if (isCustomEntityIconToken(icon)) {
    return iconsSchemas[icon]?.raw;
  }

  // Heroicons: render component to string
  const HeroIcon = HeroIcons[icon as keyof typeof HeroIcons];
  if (HeroIcon) {
    return wrapSvg(renderToStaticMarkup(<HeroIcon />));
  }

  // Font Awesome: render to string using <FontAwesomeIcon>
  const faIcon = SolidIcons[icon as keyof typeof SolidIcons];
  if (faIcon) {
    return wrapSvg(
      renderToStaticMarkup(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <FontAwesomeIcon fixedWidth icon={faIcon as any} />,
      ),
    );
  }

  return undefined;
};

export const createIconComponent = (
  iconName: string,
): FunctionComponent<SVGProps<SVGSVGElement>> => {
  return (props) => <IconRenderer icon={iconName} {...props} />;
};
